/** "Instagram", "Instagram and Facebook", "Instagram, TikTok and Facebook" */
export function joinLabels(labels: string[]) {
  return labels.length > 1
    ? `${labels.slice(0, -1).join(', ')} and ${labels[labels.length - 1]}`
    : labels.join('')
}

/**
 * Stories are published without a cover image. Shared by the composer media panel and the bulk
 * view so both explain a disabled cover picker the same way.
 */
export function storiesNoCoverMessage(networkLabels: string[]) {
  return `${joinLabels(networkLabels)} Stories don't support setting cover images.`
}
